module.exports = __webpack_public_path__ + "img/17-1.a57982c6.jpg";